var wxPub = require('./wx_lite');

module.exports = wxPub;



//////////////////
// WEBPACK FOOTER
// ./node_modules/pingpp-js/src/channels/yeepay_wx_lite_ofl.js
// module id = Uxfg
// module chunks = 5